/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { cardSkin1_item$ref } from "./cardSkin1_item.graphql";
import type { FragmentReference } from "relay-runtime";
declare export opaque type cardCms_item$ref: FragmentReference;
declare export opaque type cardCms_item$fragmentType: cardCms_item$ref;
export type cardCms_item = {|
  +dataByCategory: ?{|
    +price: ?{|
      +amount_excl_tax: ?number
    |}
  |},
  +$fragmentRefs: cardSkin1_item$ref,
  +$refType: cardCms_item$ref,
|};
export type cardCms_item$data = cardCms_item;
export type cardCms_item$key = {
  +$data?: cardCms_item$data,
  +$fragmentRefs: cardCms_item$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lang"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "cardCms_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DataByCategory",
      "kind": "LinkedField",
      "name": "dataByCategory",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount_excl_tax",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "lang",
          "variableName": "lang"
        }
      ],
      "kind": "FragmentSpread",
      "name": "cardSkin1_item"
    }
  ],
  "type": "Space",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '75c41fec51243c5298d84fd2b7550760';

module.exports = node;
